<template>
  <div class="sidebar">
    <!-- 菜单 -->
    <div class="menubar">
      <div class="menu">
        <div class="need-event menu-item" @click="() => clickMenu('main', 'operation')">
          <img src="./images/services.png" />
        </div>
        <div class="need-event menu-item" @click="() => clickMenu('main', 'status')">
          <img :src="operatorStatusIcon" />
        </div>
      </div>
      <div class="menu sub-menu" v-show="mainMenuKey == 'operation'">
        <div class="op-menu">
          <div class="need-event menu-item" @click="() => clickMenu('sub', 'logOperation')">
            <template v-if="currOperatorStatus == operatorStatusMap.offline">
              <img :src="imgs.op.login" />
              <span>上号</span>
            </template>
            <template v-else>
              <img :src="imgs.op.logout" />
              <span>下号</span>
            </template>
          </div>
          <div class="need-event menu-item" @click="() => clickMenu('sub', 'call')">
            <img :src="imgs.op.call" />
            <span>外呼电话</span>
          </div>
          <div class="need-event menu-item" @click="() => clickMenu('sub', 'transfer')">
            <img :src="imgs.op.transfer" />
            <span>电话转接</span>
          </div>
          <!-- <div class="need-event menu-item" @click="() => clickMenu('sub', 'conference')">
            <img :src="imgs.op.conference" />
            <span>多方通话</span>
          </div> -->
          <div class="need-event menu-item" @click="() => clickMenu('sub', 'listen')">
            <img :src="imgs.op.listen" />
            <span>通话监听</span>
          </div>
          <div class="need-event menu-item" @click="() => clickMenu('sub', 'insert')">
            <img :src="imgs.op.insert" />
            <span>通话强插</span>
          </div>
          <div class="need-event menu-item" @click="() => clickMenu('sub', 'abort')">
            <img :src="imgs.op.abort" />
            <span>通话强拆</span>
          </div>
          <div class="need-event menu-item" @click="() => clickMenu('sub', 'hold')">
            <template v-if="!isHolding">
              <img :src="imgs.op.hold" />
              <span>驻留</span>
            </template>
            <template v-else>
              <img :src="imgs.op.unhold" />
              <span>拾回</span>
            </template>
          </div>
          <div class="need-event menu-item" @click="() => clickMenu('sub', 'satisfaction')">
            <img :src="imgs.op.satisfaction" />
            <span>满意度</span>
          </div>
        </div>
      </div>
      <div class="menu sub-menu" v-show="mainMenuKey == 'status'">
        <div class="status-menu">
          <div class="curr-status">
            <span>当前状态：</span>
            <span>
              {{
                tool.getDictionaryValue(
                  operatorStatusDict,
                  'dictValue',
                  'dictKey',
                  currOperatorStatus
                )
              }}
            </span>
          </div>
          <div
            class="need-event menu-item"
            v-if="
              currOperatorStatus == operatorStatusMap.aftercall ||
              currOperatorStatus == operatorStatusMap.away
            "
            @click="() => clickMenu('sub', 'ready')"
          >
            就绪
          </div>
          <div
            class="need-event menu-item"
            v-if="
              currOperatorStatus != operatorStatusMap.offline &&
              currOperatorStatus != operatorStatusMap.away
            "
            @click="() => clickMenu('sub', 'away')"
          >
            离开
          </div>
        </div>
      </div>
    </div>
    <!-- 选人弹窗 -->
    <div class="operator-select need-event" v-if="isNeedOperatorsShow">
      <TransferoperatorSelect
        v-if="operatorsDialogType == 'transfer'"
        :operatorStatusDict="operatorStatusDict"
        :title="operationDescMap[operatorsDialogType]"
        currStatus="ready"
        @close="closeOperatorsDialog"
        @save="operatorSelected"
      ></TransferoperatorSelect>
      <OperatorSelect
        v-else
        :operatorStatusDict="operatorStatusDict"
        :title="operationDescMap[operatorsDialogType]"
        currStatus="incall"
        @close="closeOperatorsDialog"
        @save="operatorSelected"
      ></OperatorSelect>
    </div>
    <!-- 监听弹框 -->
    <div v-if="listenDialogShowStatus" class="need-event">
      <RBDialog title="当前监听" @close="listenDialogShowStatus=''">
        <div>
          <div>客户电话：{{ listenInfo ? listenInfo.customerTel : '' }}</div>
          <div>坐席：{{ listenInfo ? listenInfo.serviceNo : '' }}</div>
          <div class="btns">
            <el-button
              v-if="listenDialogShowStatus == 'listen'"
              type="primary"
              size="small"
              @click="listenToInsert"
            >
              插播
            </el-button>
            <el-button
              v-else-if="listenDialogShowStatus == 'insert'"
              type="primary"
              size="small"
              @click="listenFromInsert"
            >
              回到监听
            </el-button>
          </div>
        </div>
      </RBDialog>
    </div>
    <!-- 插播弹框 -->
    <div v-if="isNeedInsertDialogShow" class="need-event">
      <RBDialog title="当前插播" @close="isNeedInsertDialogShow=false">
        <div>
          <div>客户电话：{{ insertInfo ? insertInfo.customerTel : '' }}</div>
          <div>坐席：{{ insertInfo ? insertInfo.serviceNo : '' }}</div>
        </div>
      </RBDialog>
    </div>
  </div>
</template>

<script>
import OperatorSelect from './operator-select';
import TransferoperatorSelect from './transfer-operator-select';
import RBDialog from './RBDialog';
import { operatorStatusMap } from '../common';
import {
  getOperatorInfoApi,
  loginApi,
  logoutApi,
  awayApi,
  readyApi,
  transferApi,
  transferOutLineApi,
  listenApi,
  insertFromListenApi,
  listenFromInsertApi,
  insertApi,
  abortApi,
  holdApi,
  unHoldApi,
  evaluateApi,
} from '@/api/call-system/call-sidebar';

export default {
  components: {
    OperatorSelect,
    TransferoperatorSelect,
    RBDialog,
  },
  props: {
    // 坐席状态字典
    operatorStatusDict: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      // 引入侧边菜单使用的图标
      imgs: {
        status: {
          offline: require('./images/status_offline.png'),
          ready: require('./images/status_ready.png'),
          incall: require('./images/status_incall.png'),
          aftercall: require('./images/status_aftercall.png'),
          away: require('./images/status_away.png'),
        },
        op: {
          login: require('./images/op_login.png'),
          logout: require('./images/op_logout.png'),
          call: require('./images/op_call.png'),
          transfer: require('./images/op_transfer.png'),
          conference: require('./images/op_conference.png'),
          listen: require('./images/op_listen.png'),
          insert: require('./images/op_insert.png'),
          abort: require('./images/op_abort.png'),
          hold: require('./images/op_hold.png'),
          unhold: require('./images/op_unhold.png'),
          satisfaction: require('./images/op_satisfaction.png'),
        },
      },
      operatorStatusMap, // 坐席状态映射
      currOperatorDetail: {}, // 坐席的详细信息，比如岗位等
      mainMenuKey: '', // 当前选中的侧边栏主菜单对应的标识符
      subMenuKey: '', // 当前选中的侧边栏子菜单对应的标识符
      isNeedOperatorsShow: false, // 是否要展示坐席列表选择弹窗
      operatorsDialogType: '', // 当前坐席列表选择弹窗的操作类型
      operationDescMap: {
        call: '外呼电话',
        transfer: '电话转接',
        conference: '多方通话',
        listen: '通话监听',
        insert: '通话强插',
        abort: '通话强拆',
        hold: '驻留',
        satisfaction: '满意度',
      },
      selectedOperatorId: '', // 选中的坐席
      listenDialogShowStatus: '', // 监听弹框的显隐状态 '': 不显示 listen: 监听状态 insert: 插播状态
      isNeedInsertDialogShow: false, // 是否需要展示插播弹框
      isHolding: false, // 是否处于驻留状态
    };
  },
  computed: {
    /* 计算状态对应的图标 */
    operatorStatusIcon() {
      let item = Object.entries(this.operatorStatusMap).find(
        ([key, value]) => value == this.currOperatorStatus
      );
      return this.imgs.status[item[0]];
    },
    /* 坐席当前的状态 */
    currOperatorStatus() {
      return this.$store.state.callSystem.operatorStatus;
    },
    /* 坐席详情 */
    currOperatorDetail() {
      return this.$store.state.callSystem.operatorDetail;
    },
    /* 强插数据 */
    insertInfo() {
      let currInfo = null;
      let info = this.$store.state.callSystem.insertInfo;
      // 当前坐席是强插者
      if (info && this.currOperatorDetail.serviceNo == info.serviceNo) {
        currInfo = {
          customerTel: info.customerTel,
          serviceNo: info.toPhone,
        };
      }
      return currInfo;
    },
    /* 监听数据 */
    listenInfo() {
      let currInfo = null;
      let info = this.$store.state.callSystem.listenInfo;
      // 当前用户是监听者
      if (info && this.currOperatorDetail.serviceNo == info.serviceNo) {
        currInfo = {
          customerTel: info.customerTel,
          serviceNo: info.toPhone,
        };
      }
      return currInfo;
    },
  },
  watch: {
    currOperatorStatus(newVal, oldVal) {
      if (newVal == this.operatorStatusMap.aftercall) {
        this.resetAfterHangUp();
      }
    },
  },
  created() {
    this.getOperatorStatus('init');
  },
  methods: {
    /* 挂断后重置本地数据 */
    resetAfterHangUp() {
      this.isNeedOperatorsShow = false;
      this.operatorsDialogType = '';
      this.selectedOperatorId = '';
      this.listenDialogShowStatus = '';
      this.isNeedInsertDialogShow = false;
      this.isHolding = false;
      this.$store.commit('callSystem/SET_INSERT_INFO', null);
      this.$store.commit('callSystem/SET_LISTEN_INFO', null);
    },
    /* 获取坐席的最新状态 */
    getOperatorStatus(flag) {
      getOperatorInfoApi().then(({ data }) => {
        this.currOperatorDetail = data;
        this.$store.commit('callSystem/SET_OPERATOR_DETAIL', this.currOperatorDetail);
        this.$store.commit(
          'callSystem/SET_OPERATOR_STATUS',
          this.currOperatorDetail.workStatus || this.operatorStatusMap.offline
        );
        // 重新进入时如果不是离线状态需要通知主页面
        if (
          flag == 'init' &&
          this.currOperatorDetail.workStatus != this.operatorStatusMap.offline
        ) {
          this.$emit('operation', 'back');
        }
      });
    },
    /* 点击菜单 */
    clickMenu(level, flag) {
      if (level == 'main') {
        // 再次点击相同的一级按钮时隐藏二级列表
        if (this.mainMenuKey == flag) {
          this.mainMenuKey = '';
        } else {
          this.mainMenuKey = flag;
        }
      } else if (level == 'sub') {
        if (this.currOperatorStatus == this.operatorStatusMap.offline && flag != 'logOperation') {
          this.$message.warning('请先完成上号');
          return;
        }
        /**
         * 通话监听和通话强插这两个操作只有主管自己挂断电话时有推送bye事件外，接通等是没有事件推送的，所以这两种场景下页面展示的状态并非真实的。
         * 收到bye事件后会自动进入话后处理状态，此时如果再次监听或者强插，并且再次挂断，此时状态没有任何变化，一直都是话后处理，所以不会触发resetAfterHangUp去自动关闭弹窗界面。
         * 经过与产品经理协商，这里只需要增加弹窗的关闭按钮允许用户主动去关闭即可。
         */
        if (flag == 'listen' || flag == 'insert' || flag == 'abort') {
          if (this.currOperatorDetail.serviceRole != 2) {
            // serviceRole: 1-话务员/2-话务主管
            this.$message.warning('您没有当前权限');
          } else {
            this.showOperatorsDialog(flag);
          }
          return;
        }
        switch (flag) {
          case 'ready':
          case 'away':
            this.switchStatus(flag);
            break;
          case 'logOperation':
            this.dealLogOperation();
            break;
          case 'call':
            this.dealCall(flag);
            break;
          case 'transfer':
            this.dealTransfer(flag);
            break;
          case 'conference':
            this.dealConference(flag);
            break;
          case 'hold':
            this.dealHold();
            break;
          case 'satisfaction':
            this.dealSatisfaction();
            break;
          default:
        }
      }
    },
    /* 切换状态 */
    switchStatus(status) {
      let fn = status == 'away' ? awayApi : readyApi;
      fn({
        id: this.currOperatorDetail.id,
      }).then(() => {
        this.$store.commit('callSystem/SET_OPERATOR_STATUS', this.operatorStatusMap[status]);
        this.$message.success('操作成功!');
      });
    },
    /* 上/下号 */
    dealLogOperation() {
      if (this.currOperatorStatus == this.operatorStatusMap.offline) {
        loginApi({
          id: this.currOperatorDetail.id,
        }).then(() => {
          this.$store.commit('callSystem/SET_OPERATOR_STATUS', this.operatorStatusMap.ready);
          this.$emit('operation', 'login');
        });
      } else {
        logoutApi({
          id: this.currOperatorDetail.id,
        }).then(() => {
          this.$store.commit('callSystem/SET_OPERATOR_STATUS', this.operatorStatusMap.offline);
          this.$emit('operation', 'logout');
        });
      }
    },
    /* 外呼电话 */
    dealCall(operation) {
      if (this.currOperatorStatus == this.operatorStatusMap.incall) {
        this.$message.warning('您当前正在通话中');
        return;
      }
      this.$emit('operation', operation);
    },
    /* 电话转接 */
    dealTransfer(operation) {
      if (this.currOperatorStatus != this.operatorStatusMap.incall) {
        this.$message.warning('您当前不在通话中');
        return;
      }
      this.showOperatorsDialog(operation);
    },
    /* 多方通话 */
    dealConference(operation) {
      // tips: 由于话机盒子提供的信息不足以支撑页面的展示效果，所以web页面的入口直接屏蔽
      return;
      if (this.currOperatorStatus != this.operatorStatusMap.incall) {
        this.$message.warning('您当前非通话中，不能多方通话');
        return;
      }
      this.showOperatorsDialog(operation);
    },
    /* 驻留/拾回 */
    dealHold() {
      if (this.currOperatorStatus != this.operatorStatusMap.incall && !this.isHolding) {
        this.$message.warning('您当前非通话中，不能驻留');
        return;
      }
      let fn = this.isHolding ? unHoldApi : holdApi;
      fn(); // 不用等接口返回，接口返回非常慢，但实际操作早就生效了
      this.isHolding = !this.isHolding;
    },
    /* 满意度 */
    dealSatisfaction() {
      if (this.currOperatorStatus != this.operatorStatusMap.incall) {
        this.$message.warning('您当前非通话中，不能发送满意度');
        return;
      }
      evaluateApi(); // 不用等接口返回，接口返回非常慢，但实际操作早就生效了
      // 后端没有bye事件，需要页面主动切换成话后处理状态
      this.$store.commit('callSystem/SET_OPERATOR_STATUS', this.operatorStatusMap.aftercall);
    },
    // 显示坐席列表选择弹框 电话转接|多方通话|通话监听|通话强插|通话强拆
    showOperatorsDialog(operation) {
      this.operatorsDialogType = operation;
      this.isNeedOperatorsShow = true;
    },
    /* 选中坐席后的回调 */
    operatorSelected(id, type) {
      this.selectedOperatorId = id;
      if (this.operatorsDialogType == 'listen') {
        this.startListen();
      } else if (this.operatorsDialogType == 'insert') {
        this.startInsert();
      } else if (this.operatorsDialogType == 'abort') {
        abortApi({
          phone: this.selectedOperatorId,
        }).then(() => {
          this.$message.success('操作成功!');
        });
      } else if (this.operatorsDialogType == 'transfer') {
        let fn = type == 'inline' ? transferApi : transferOutLineApi;
        fn({
          toPhone: this.selectedOperatorId,
        }).then(() => {
          this.$message.success('操作成功!');
        });
      }
      this.closeOperatorsDialog();
    },
    /* 关闭坐席列表选择弹框 */
    closeOperatorsDialog() {
      this.isNeedOperatorsShow = false;
      this.operatorsDialogType = '';
    },
    /* 进入监听 */
    startListen() {
      // 不用等接口返回，接口返回非常慢，但实际操作早就生效了
      listenApi({ toPhone: this.selectedOperatorId });
      this.listenDialogShowStatus = 'listen';
    },
    /* 从监听转成插播 */
    listenToInsert() {
      // 不用等接口返回，接口返回非常慢，但实际操作早就生效了
      insertFromListenApi();
      this.listenDialogShowStatus = 'insert';
    },
    /* 从插播回到监听 */
    listenFromInsert() {
      // 不用等接口返回，接口返回非常慢，但实际操作早就生效了
      listenFromInsertApi();
      this.listenDialogShowStatus = 'listen';
    },
    /* 进入强插 */
    startInsert() {
      // 不用等接口返回，接口返回非常慢，但实际操作早就生效了
      insertApi({ toPhone: this.selectedOperatorId });
      this.isNeedInsertDialogShow = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.sidebar {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9;
}

/* 需要拦截按键的dom元素需要加上此css类 */
.need-event {
  pointer-events: auto;
}

/* 侧边栏菜单 */
.menubar {
  position: relative;
  height: 100%;
  display: flex;
  justify-content: flex-end;
  margin-right: 20px;

  .menu {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;

    .menu-item {
      cursor: pointer;
      box-sizing: border-box;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin-bottom: 10px;
    }

    img {
      max-width: 50px;
      max-height: 50px;
    }

    .op-menu {
      box-sizing: border-box;
      width: 100%;
      padding: 10px 10px 0;
      background: #1c2b36;
      color: #fff;
      font-size: 14px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      img {
        max-width: 30px;
        max-height: 30px;
      }
      .menu-item {
        margin-bottom: 15px;
      }
    }

    .status-menu {
      box-sizing: border-box;
      width: 100%;
      padding: 8px;
      min-height: 130px;
      background: #1c2b36;
      color: #fff;
      font-size: 14px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .curr-status {
        margin-bottom: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
      }

      .menu-item {
        font-weight: bolder;
        font-size: 16px;
      }
    }
  }

  .sub-menu {
    margin-left: 10px;
    // 设置这个宽度是为了切换一级菜单时位置不会左右挪动
    width: 80px;
  }
}

/* 选人弹窗 */
.operator-select {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

/* 按钮组 */
.btns {
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: space-around;
}

/* 单个按钮 */
.btn {
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
}
</style>
